export const initFBPixel = (pixelId) => {
    // eslint-disable-next-line no-unused-expressions
    !(function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = "2.0";
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
    })(
        window,
        document,
        "script",
        "https://connect.facebook.net/en_US/fbevents.js",
    );

    // Initialize the pixel with your pixel ID
    fbq("init", pixelId); // eslint-disable-line no-undef
};

export const trackFBEvent = (eventName, params = {}) => {
    if (window.fbq) {
        window.fbq("track", eventName, params);
        console.log("FB Pixel Event:", eventName, params); // Add logging
    } else {
        console.warn("Facebook Pixel is not initialized");
    }
};
